import React from 'react';
import PropTypes from 'prop-types';
import { TextField, Tooltip } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import localization from '../../localization';

const InputCustom = ({
  label,
  value,
  onChangeInput,
  isRequired,
  isDisabled,
  isMultiline,
  helperText,
  hasError,
  rowsMax,
  tooltip,
  onBlur,
  testing,
  placeholder,
  autoFocus,
  style,
  displayRows: rows,
}) => (
  <form autoComplete='off' style={{ width: '100%', position: 'relative' }}>
    <TextField
      onKeyDown={(e) => {
        if (e.code === 'Enter' && !isMultiline) {
          e.preventDefault();
        }
      }}
      autoFocus={autoFocus}
      maxRows={rowsMax}
      error={hasError}
      data-test={label}
      helperText={helperText}
      disabled={isDisabled}
      multiline={testing ? false : isMultiline}
      required={isRequired}
      name={label}
      value={value || ''}
      fullWidth
      style={style}
      onBlur={onBlur}
      label={label ? localization.t(`labels.${label}`) : ''}
      type='text'
      InputProps={{
        form: { autocomplete: 'off' },
        rows,
      }}
      InputLabelProps={testing || label ? null : { shrink: false }}
      onChange={onChangeInput}
      variant='outlined'
      placeholder={placeholder}
    />

    {
      tooltip && (
        <Tooltip
          disableInteractive
          placement='right'
          title={tooltip}
          style={{ position: 'absolute', right: 10, top: 16 }}
        >
          <HelpIcon />
        </Tooltip>
      )
    }
  </form>
);

InputCustom.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isMultiline: PropTypes.bool,
  hasError: PropTypes.bool,
  onChangeInput: PropTypes.func,
  onBlur: PropTypes.func,
  helperText: PropTypes.string,
  rowsMax: PropTypes.number,
  tooltip: PropTypes.string,
  testing: PropTypes.bool,
  autoFocus: PropTypes.bool,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  displayRows: PropTypes.number,
};

export default InputCustom;
